<script>
  export default {
    name: '',
    props: {
      color: {
        type: String,
        default: '#ffffff'
      }
    },
    computed: {
      styles() {
        return {
          fill: this.color
        }
      }
    }
  }
</script>

<template lang="pug">
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17" :style="styles">
    <path fill-rule="evenodd" d="M22,5.92418988 C21.2643788,6.25038862 20.4732751,6.47136195 19.6434294,6.57036948 C20.4904938,6.06241779 21.1409781,5.2584001 21.4475667,4.30037068 C20.6545498,4.77053689 19.776396,5.11204113 18.8418032,5.29570728 C18.093268,4.49838575 17.0271434,4 15.8467057,4 C13.5805333,4 11.7433935,5.83713978 11.7433935,8.10331221 C11.7433935,8.42472797 11.7797441,8.73801267 11.8495755,9.03838336 C8.43931603,8.86715294 5.41599904,7.23376779 3.39232333,4.751405 C3.03886165,5.35740763 2.83654191,6.0619395 2.83654191,6.81430109 C2.83654191,8.23771374 3.56116226,9.49372235 4.66220256,10.2293435 C3.98923831,10.2082985 3.35692933,10.0236757 2.8035394,9.71613058 C2.8030611,9.73334928 2.8030611,9.75056798 2.8030611,9.76778668 C2.8030611,11.7560684 4.21738611,13.414325 6.09470286,13.7912232 C5.75032883,13.8849695 5.3877795,13.9351907 5.01375105,13.9351907 C4.74925266,13.9351907 4.49192873,13.9093627 4.24177927,13.8615329 C4.76360158,15.49157 6.2793256,16.6782255 8.07485352,16.711228 C6.67057276,17.81179 4.90087289,18.4675356 2.9785962,18.4675356 C2.64761449,18.4675356 2.32093746,18.4484037 2,18.4101399 C3.81561641,19.5747937 5.97273706,20.2539758 8.28960899,20.2539758 C15.8371398,20.2539758 19.9643669,14.0011957 19.9643669,8.57921798 C19.9643669,8.4012914 19.9605405,8.22432142 19.9524094,8.04830802 C20.7540356,7.46956834 21.4499581,6.74686117 22,5.92418988" transform="translate(-2 -4)"/>
  </svg>
</template>

<style lang="scss" scope>
svg {
  display: block;
}
</style>
